import Plyr from 'plyr';
import RangeTouch from 'rangetouch'; // Fix for ios range..
import tippy from 'tippy.js';

export default class VideoPlayer {
	constructor(video) {
		this.video = video;
		this.volumeTippies = [];
		this.element = null;
		this.player = null;
		this.videoHasPlayed = false;
		this.posterHidden = false;

		this.textTracks = this.video.querySelectorAll('track');
	}

	init() {
		this.element = this.video.closest('.c-video-player');
		this.poster = this.element.querySelector('.c-video-player__poster');

		let controlsArray = ['play', 'current-time', 'progress', 'duration', 'settings', 'mute', 'volume', 'fullscreen'];
		let settingsArray = ['captions', 'quality'];
		if (this.textTracks) {
			controlsArray = ['play', 'current-time', 'progress', 'duration', 'captions', 'settings', 'mute', 'volume', 'fullscreen'];
			settingsArray = ['captions', 'quality'];
		}

		this.player = new Plyr(this.video, {
			controls: controlsArray,
			seekTime: 10,
			volume: 1,
			settings: settingsArray,
			captions: {
				active: false,
			},
			quality: {
				default: 1280,
				options: [640, 720, 960, 1280, 1440, 1920],
			},
			tooltips: {
				controls: false,
				seek: true,
			},
			iconUrl: window.WPURLS.themeUrl + '/symbols.svg',
			loadSprite: true,
			iconPrefix: 'plyr',
			hideControls: true,
			debug: false,
		});

		this.element.addEventListener('click', e => {
			if (e.target.closest('[data-play]')) {
				this.togglePlay();
			}
		});

		this.player.on('pause', event => {
			this.element.classList.remove('is-playing');
		});

		this.player.on('playing', event => {
			this.hidePoster();

			if (!this.videoHasPlayed) {
				this.videoHasPlayed = true;
				this.element.classList.add('has-played');
			}
		});

		this.player.on('ready', () => {
			if (this.volumeTippies) {
				this.volumeTippies.forEach(volumeTippy => volumeTippy.destroy());
			}

			this.volumeTippies = tippy(this.element.querySelectorAll('[data-plyr="mute"]'), {
				content: reference => {
					return reference.nextElementSibling;
				},
				allowHTML: true,
				interactive: true,
				placement: 'top',
				theme: 'volume-slider',

				arrow: false,
				zIndex: -1,
				offset: [0, -34],
			});

			const seekInput = this.video.querySelector('[data-plyr="seek"]');
			const seekRange = new RangeTouch(seekInput);

			const volumeInput = this.video.querySelector('[data-plyr="volume"]');
			const volumeRange = new RangeTouch(volumeInput);
		});
	}

	checkPlayer() {
		if (!this.player) {
			return;
		}
	}

	togglePlay() {
		this.checkPlayer();
		this.player.togglePlay();
	}

	play() {
		this.checkPlayer();
		this.player.play();
	}

	pause() {
		this.checkPlayer();
		this.player.pause();
	}

	hidePoster() {
		if (!this.poster || this.posterHidden) {
			return;
		}

		this.poster.classList.remove('is-active');
		this.posterHidden = true;
	}
}
